<script>
  import { cutReveal } from '../lib/cutReveal.js';
  import Img from '../components/Img.svelte';
  import { onMount } from 'svelte';
  import Footer from '../components/Footer.svelte';
  import Loader from '../components/Loader.svelte';
  import { loadStoreData } from '../lib/storeData.js';
  import Navbar from '../components/Navbar.svelte';
  import { lookbookCover } from '../lib/lookbook.js';

  let data = null;
  let loading = true;

  onMount(async () => {
    try {
      data = await loadStoreData();
      } finally { loading = false; }
  });

  function goLookbook(id) {
    if (window.__navigate) window.__navigate(`/lookbook/${id}`);
  }
</script>

<svelte:head>
  <title>{data ? `Lookbook — ${data.site.metaTitle || data.site.name}` : 'Lookbook'}</title>
  <meta name="description" content={data?.site?.metaDescription || "Browse the Others. lookbook — editorial photography and campaign imagery from our latest collections."} />
</svelte:head>

{#if loading || !data}
  <Loader />
{:else}
  <div class="min-h-screen flex flex-col">
    <Navbar siteName={data.site.name} logo={data.site.logo} logoHeight={data.site.navLogoSize} />

    <div class="flex-1 w-full pt-24 md:pt-28 pb-16 md:pb-20 px-4 sm:px-6 md:px-10 max-w-7xl mx-auto">
      <div class="mb-8 md:mb-12">
        <p class="text-label mb-2">Editorial</p>
        <h1 use:cutReveal class="text-4xl md:text-5xl font-display font-bold">Lookbook</h1>
      </div>

      {#if data.lookbooks.length}
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-8 md:gap-6">
          {#each data.lookbooks as lb}
            {@const cover = lookbookCover(lb)}
            <button
              onclick={() => goLookbook(lb.id)}
              class="group text-left"
              aria-label="Open {lb.title} lookbook"
            >
              <!-- Cover image -->
              <div class="aspect-[3/4] overflow-hidden bg-secondary mb-4 relative">
                {#if cover}
                  <Img
                    src={cover}
                    sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                    crop="3:4"
                    alt={lb.title}
                    class="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
                  />
                {:else}
                  <div class="w-full h-full flex items-center justify-center text-muted-foreground text-sm">No cover</div>
                {/if}
              </div>

              <div>
                <h2 class="font-display font-bold text-lg group-hover:underline underline-offset-2 transition-all">{lb.title}</h2>
                {#if lb.description}
                  <p class="text-sm text-muted-foreground mt-1 line-clamp-2">{lb.description}</p>
                {/if}
              </div>
            </button>
          {/each}
        </div>
      {:else}
        <div class="text-center py-24 text-muted-foreground">No lookbooks yet.</div>
      {/if}
    </div>

    <Footer {data} />
  </div>
{/if}
